import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

const typeLabels = {
  AVAILABLE: "Dostępny",
  UNAVAILABLE: "Niedostępny",
  PREFERRED: "Preferowana dostępność"
};

const normalizeTime = value => value ? String(value).slice(0, 5) : "";

const ScheduleAvailabilityForm = ({ employeeId, date, availability, onSave, onDelete, onCancel, saving }) => {
  const [form, setForm] = useState({
    type: "UNAVAILABLE",
    timeFrom: "",
    timeTo: "",
    comments: ""
  });

  useEffect(() => {
    setForm({
      type: availability?.type ?? "UNAVAILABLE",
      timeFrom: normalizeTime(availability?.timeFrom),
      timeTo: normalizeTime(availability?.timeTo),
      comments: availability?.comments ?? ""
    });
  }, [availability]);

  const submit = async event => {
    event.preventDefault();
    const saved = await onSave(availability, {
      EID: Number(employeeId),
      dateFrom: availability?.dateFrom ?? date,
      dateTo: availability?.dateTo ?? date,
      type: form.type,
      timeFrom: form.timeFrom || null,
      timeTo: form.timeTo || null,
      recurrence: availability?.recurrence ?? "NONE",
      daysOfWeek: availability?.daysOfWeek ?? [],
      comments: form.comments,
      version: availability?.version ?? null
    });
    if (saved) onCancel();
  };

  const remove = async () => {
    if (!availability?.id) return;
    const removed = await onDelete(availability.id);
    if (removed) onCancel();
  };

  return (
    <Form onSubmit={submit} className="schedule-quick-form">
      {availability && (availability.dateFrom !== date || availability.dateTo !== date || availability.recurrence === "WEEKLY") && (
        <div className="schedule-quick-form-info">
          Edytujesz wpis obejmujący {availability.dateFrom} – {availability.dateTo}{availability.recurrence === "WEEKLY" ? " (cykliczny tygodniowo)" : ""}.
        </div>
      )}
      <Form.Group>
        <Form.Label>Typ</Form.Label>
        <Form.Select value={form.type} onChange={event => setForm(current => ({ ...current, type: event.target.value }))}>
          {Object.entries(typeLabels).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </Form.Select>
      </Form.Group>
      <div className="schedule-quick-form-times">
        <Form.Group>
          <Form.Label>Od</Form.Label>
          <Form.Control type="time" value={form.timeFrom} onChange={event => setForm(current => ({ ...current, timeFrom: event.target.value }))} required={!!form.timeTo} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Do</Form.Label>
          <Form.Control type="time" value={form.timeTo} onChange={event => setForm(current => ({ ...current, timeTo: event.target.value }))} required={!!form.timeFrom} />
        </Form.Group>
      </div>
      <Form.Text>Brak godzin oznacza wpis obowiązujący przez cały dzień.</Form.Text>
      <Form.Group>
        <Form.Label>Uwagi</Form.Label>
        <Form.Control as="textarea" rows={2} value={form.comments} onChange={event => setForm(current => ({ ...current, comments: event.target.value }))} />
      </Form.Group>
      <div className="schedule-form-actions mt-3">
        <Button type="submit" variant="primary" disabled={saving}>{availability ? "Zapisz" : "Dodaj"}</Button>
        {availability?.id && <Button type="button" variant="outline-danger" onClick={remove} disabled={saving}>Usuń</Button>}
        <Button type="button" variant="secondary" onClick={onCancel} disabled={saving}>Anuluj</Button>
      </div>
    </Form>
  );
};

export default ScheduleAvailabilityForm;
